export default __webpack_public_path__ + "static/media/AppHome.79e9f2c4.png";